import { useEffect, useState } from "react";
import { Cpu, Ruler, Cog, Loader2 } from "lucide-react";

const STEPS = [
  { label: "Reading 2D drawing & extracting GD&T", icon: Ruler },
  { label: "Identifying material, heat & surface treatment", icon: Cpu },
  { label: "Simulating manufacturing route, tooling & fixtures", icon: Cog },
  { label: "Calculating regional cost estimates (INR)", icon: Loader2 },
];

export const AnalyzingOverlay = () => {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setActive((a) => Math.min(a + 1, STEPS.length - 1)), 6000);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid="analyzing-overlay"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-background/95 backdrop-blur-md"
    >
      <div className="blueprint-grid absolute inset-0 opacity-40" />
      <div className="relative w-full max-w-md px-6">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-sm bg-primary/10">
            <Cog className="h-8 w-8 animate-spin text-primary" style={{ animationDuration: "3s" }} />
          </div>
          <h2 className="font-display text-2xl font-black tracking-tight">Analysing your part</h2>
          <p className="mt-1 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">
            AI Manufacturing Engine
          </p>
        </div>
        <div className="space-y-3">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            const done = i < active;
            const current = i === active;
            return (
              <div
                key={i}
                className={`flex items-center gap-3 rounded-sm border px-4 py-3 transition-colors duration-300 ${
                  current ? "border-primary bg-primary/5" : done ? "border-border bg-muted/40" : "border-border/60 opacity-50"
                }`}
              >
                <Icon
                  className={`h-4 w-4 shrink-0 ${current ? "animate-spin text-primary" : done ? "text-success" : "text-muted-foreground"}`}
                  style={current ? { animationDuration: "1.5s" } : {}}
                />
                <span className="text-sm font-medium">{s.label}</span>
              </div>
            );
          })}
        </div>
        <p className="mt-6 text-center text-xs text-muted-foreground">
          This can take up to a minute for detailed drawings.
        </p>
      </div>
    </div>
  );
};
